export default __webpack_public_path__ + "static/chaff-dc1950024592978b340546bbe21c3379.gif";